export default {
  data() {
    return {
      inputType: 'checkboxes',
      inputTypeDef: {}
    }
  }
}
